import React from 'react';
import { Form, Row, Col, Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface FilterCriteria {
  id: string;
  ean: string;
  description: string;
}

interface FilterComponentProps {
  onFilterChange: (criteria: FilterCriteria) => void;
}

const FilterComponent: React.FC<FilterComponentProps> = ({ onFilterChange }) => {
  const [filterCriteria, setFilterCriteria] = React.useState<FilterCriteria>({
    id: '',
    ean: '',
    description: '',
  });
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilterCriteria(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilterChange(filterCriteria);
  };

  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row className="align-items-end">
          <Col md={3} className="ms-5">
            <Form.Group controlId="formId">
              <Form.Label className='fs-5 fw-medium text-secondary mx-2'>ID</Form.Label>
              <Form.Control
                type="text"
                name="id"
                value={filterCriteria.id}
                onChange={handleChange}
                placeholder={t("devices.filter.enterID")}
                className='text-secondary bg-light fw-medium'
              />
            </Form.Group>
          </Col>
          <Col md={3} className="ms-5">
            <Form.Group controlId="formName">
              <Form.Label className='fs-5 fw-medium text-secondary mx-2'>EAN</Form.Label>
              <Form.Control
                type="text"
                name="ean"
                value={filterCriteria.ean}
                onChange={handleChange}
                placeholder={t("devices.filter.enterEAN")}
                className='text-secondary bg-light fw-medium'
              />
            </Form.Group>
          </Col>
          <Col md={3} className="ms-5">
            <Form.Group controlId="formDescription">
              <Form.Label className='fs-5 fw-medium text-secondary mx-2'>{t("description")}</Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={filterCriteria.description}
                onChange={handleChange}
                placeholder={t("tools.enterDescription")}
                className='text-secondary bg-light fw-medium'
              />
            </Form.Group>
          </Col>
          <Col md={1} className='ms-4'>
            <Button variant="secondary" className="py-1 px-3 fs-5" type="submit">{t("apply")}</Button>
          </Col>
        </Row>
      </Form>
    </Card.Body>
  );
};

export default FilterComponent;
